import { Flex, Text, VStack, Heading, Link, Box } from '@chakra-ui/react'

const Terms = () => {
	return (
		<Flex
			w="100%"
			direction="column"
			align="center"
			justify="flex-start"
			p={{ base: 6, md: 8 }}
		>
			<VStack
				spacing={6}
				maxW="800px"
				w="100%"
				align="flex-start"
			>
				<VStack spacing={2} align="center" w="100%">
					<Heading as="h1" size="xl" color="white">
						Terms of Use
					</Heading>
					<Text fontSize="sm" color="gray.400">
						Effective Date: September 7, 2025
					</Text>
					<Text fontSize="sm" color="gray.400">
						Last Updated: September 9, 2025
					</Text>
				</VStack>

				<Text color="gray.300">
					Welcome to TIMECHAIN CALENDAR (&ldquo;the App&rdquo;). These Terms of Use (&ldquo;Terms&rdquo;) govern your access to and use of the App, which is provided by TIMECHAIN CALENDAR LLC (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;). By downloading, accessing, or using the App, you agree to these Terms. If you do not agree, you must not use the App.
				</Text>

				<VStack spacing={4} align="flex-start" w="100%">
					<Heading as="h2" size="md" color="white">
						1. Eligibility
					</Heading>
					<Text color="gray.300">
						You must be at least 13 years old (or the minimum age of digital consent in your jurisdiction) to use the App. If you are under 18, you represent that you have your parent&apos;s or guardian&apos;s consent. Use of the App is void where prohibited by law.
					</Text>

					<Heading as="h2" size="md" color="white">
						2. License Grant
					</Heading>
					<Text color="gray.300">
						We grant you a limited, non-exclusive, non-transferable, revocable license to download, install, and use the App solely for personal, non-commercial purposes, subject to these Terms and the applicable app store&apos;s terms and conditions.
					</Text>

					<Heading as="h2" size="md" color="white">
						3. Subscriptions
					</Heading>
					<VStack spacing={2} align="flex-start" pl={4}>
						<Text color="gray.300">• Certain features of the App may require a subscription.</Text>
						<Text color="gray.300">• Subscription payments are processed through Apple&apos;s App Store or Google Play Store and are subject to their respective terms, conditions, and policies.</Text>
						<Text color="gray.300">• Subscriptions automatically renew unless canceled at least 24 hours before the end of the current billing period.</Text>
						<Text color="gray.300">• You may manage subscriptions and turn off auto-renewal in your account settings.</Text>
						<Text color="gray.300">• All subscription fees are non-refundable except as required by law or the app store&apos;s policies.</Text>
					</VStack>

					<Heading as="h2" size="md" color="white">
						4. Acceptable Use
					</Heading>
					<Text color="gray.300">
						You agree not to:
					</Text>
					<VStack spacing={2} align="flex-start" pl={4}>
						<Text color="gray.300">• Use the App for any unlawful or unauthorized purpose.</Text>
						<Text color="gray.300">• Upload, transmit, or distribute any harmful code, spam, or offensive content.</Text>
						<Text color="gray.300">• Reverse engineer, decompile, or otherwise attempt to extract source code.</Text>
						<Text color="gray.300">• Interfere with or disrupt the operation of the App or its servers.</Text>
						<Text color="gray.300">• Use the App to engage in any activity that could harm the Bitcoin network or its participants.</Text>
					</VStack>

					<Heading as="h2" size="md" color="white">
						5. Intellectual Property
					</Heading>
					<Text color="gray.300">
						All content, software, features, and functionality of the App are owned by us or our licensors and are protected by intellectual property laws. You may not use our trademarks, logos, or content without prior written consent. The TIMECHAIN CALENDAR name and logo are trademarks of TIMECHAIN CALENDAR LLC.
					</Text>

					<Heading as="h2" size="md" color="white">
						6. User Content
					</Heading>
					<Text color="gray.300">
						If the App allows you to upload or submit content:
					</Text>
					<VStack spacing={2} align="flex-start" pl={4}>
						<Text color="gray.300">• You retain ownership of your content.</Text>
						<Text color="gray.300">• You grant us a worldwide, non-exclusive, royalty-free license to use, display, and distribute your content solely for operating and improving the App.</Text>
						<Text color="gray.300">• You represent that your content does not infringe on the rights of others.</Text>
					</VStack>

					<Heading as="h2" size="md" color="white">
						7. Privacy
					</Heading>
					<Text color="gray.300">
						Your use of the App is also governed by our <Link href="/privacy" color="orange.400">Privacy Policy</Link>, which explains how we collect, use, and share your information. Please review it carefully.
					</Text>

					<Heading as="h2" size="md" color="white">
						8. Third-Party Services
					</Heading>
					<Text color="gray.300">
						The App may integrate with third-party services (e.g., Apple, Google). We are not responsible for the content, policies, or practices of these third parties. Your use of their services is subject to their terms.
					</Text>

					<Heading as="h2" size="md" color="white">
						9. Bitcoin Network Disclaimer
					</Heading>
					<Text color="gray.300">
						The App provides information about the Bitcoin network for educational and informational purposes. We do not provide financial advice, and the App should not be used as the sole basis for making financial decisions. Bitcoin prices and network data are volatile and may not be accurate in real-time.
					</Text>

					<Heading as="h2" size="md" color="white">
						10. Disclaimer of Warranties
					</Heading>
					<Text color="gray.300">
						The App is provided on an &ldquo;AS IS&rdquo; and &ldquo;AS AVAILABLE&rdquo; basis. We disclaim all warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee that the App will be error-free, secure, or continuously available.
					</Text>

					<Heading as="h2" size="md" color="white">
						11. Limitation of Liability
					</Heading>
					<Text color="gray.300">
						To the fullest extent permitted by law, we are not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the App, including but not limited to any financial losses related to Bitcoin transactions or investments, even if we were advised of the possibility of such damages.
					</Text>

					<Heading as="h2" size="md" color="white">
						12. Termination
					</Heading>
					<Text color="gray.300">
						We may suspend or terminate your access to the App at any time, without notice, for conduct that violates these Terms or is otherwise harmful to other users, us, or third parties.
					</Text>

					<Heading as="h2" size="md" color="white">
						13. Governing Law
					</Heading>
					<Text color="gray.300">
						These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, without regard to conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts located in Delaware.
					</Text>

					<Heading as="h2" size="md" color="white">
						14. App Store Terms
					</Heading>
					<Text color="gray.300">
						You acknowledge that these Terms are between you and TIMECHAIN CALENDAR LLC, not Apple or Google. Apple and Google are not responsible for the App or its content. They have no obligation to provide maintenance or support. To the extent these Terms conflict with the app store&apos;s terms, the app store&apos;s terms control.
					</Text>

					<Heading as="h2" size="md" color="white">
						15. Changes to Terms
					</Heading>
					<Text color="gray.300">
						We may update these Terms from time to time. Updates will be posted in the App or on our website with the &ldquo;Last Updated&rdquo; date. Continued use of the App after changes constitutes acceptance of the new Terms.
					</Text>

					<Heading as="h2" size="md" color="white">
						16. Contact
					</Heading>
					<Text color="gray.300">
						If you have questions about these Terms, please contact us at:
					</Text>
					<VStack spacing={1} align="flex-start" pl={4}>
						<Text color="gray.300">TIMECHAIN CALENDAR LLC</Text>
						<Text color="gray.300">Email: support@timechaincalendar.com</Text>
						<Text color="gray.300">Address: 530 Schoolhouse Rd Ste G, Hockessin, DE 19707</Text>
					</VStack>
				</VStack>
			</VStack>
			
			{/* Bottom Spacer */}
			<Box h="100px" />
		</Flex>
	)
}

export default Terms